/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";

import { useTranslation } from "react-i18next";

import Badge from "@/components/Badge/Badge";
import { BadgeColors } from "@/components/Badge/types";
import { Typography } from "@mui/material";

import { CREDITS_HEALTH, CreditsDto } from "../../../types";

interface HealthSectionProps {
  creditsData: CreditsDto;
}

const HealthSection = ({ creditsData }: HealthSectionProps) => {
  const { t } = useTranslation();

  const healthBadgeColors: Record<CREDITS_HEALTH, BadgeColors> = {
    [CREDITS_HEALTH.Healthy]: "success",
    [CREDITS_HEALTH.InOverdraft]: "warning",
    [CREDITS_HEALTH.LowCredits]: "warning",
    [CREDITS_HEALTH.LimitReached]: "critical",
    [CREDITS_HEALTH.OverdraftLimitReached]: "critical"
  };

  const badgeColor = healthBadgeColors[creditsData.health] ?? "light";

  return (
    <div
      css={css({
        display: "flex",
        gap: "8px",
        alignItems: "center"
      })}
    >
      <Typography variant="h5">{creditsData.total}</Typography>

      <Badge color={badgeColor}>
        {t(`Dashboard##credits health##${creditsData.health}`)}
      </Badge>
    </div>
  );
};

export default HealthSection;
